import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('goals_ssr_smart_card_relay');
	},
};
